import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const OfferSection = () => {
  return <section className="w-full bg-white py-16 px-4 md:px-8 lg:px-16" data-id="element-115">
      <div className="max-w-6xl mx-auto" data-id="element-116">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-117">
          <div className="md:w-2/5" data-id="element-118">
            <div className="bg-gradient-to-br from-red-500 to-red-700 p-2 rounded-lg shadow-lg" data-id="element-119">
              <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rAxtck2KSrEie67kv20z5caGwT4yUuBxRXLAMn" alt="E-book 'Od Frustracji do Siły'" className="w-full h-auto rounded-md" data-id="element-120" />
            </div>
          </div>
          <div className="md:w-3/5" data-id="element-121">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-122">
              E-book "Od Frustracji do Siły"
            </h2>
            <p className="text-lg text-gray-700 mb-6" data-id="element-123">
              Kompletny przewodnik po Metodzie Odwróconej Polarności, który krok
              po kroku przeprowadzi Cię przez proces odzyskania namiętności w
              Twoim małżeństwie.
            </p>
            <div className="mb-6" data-id="element-124">
              <h3 className="font-serif text-xl font-bold text-gray-800 mb-3" data-id="element-125">
                Co otrzymasz:
              </h3>
              <ul className="space-y-2" data-id="element-126">
                {['Szczegółowy 21-dniowy plan działania - dokładnie wiesz, co robić każdego dnia', '5 kluczowych technik Odwróconej Polarności, które zmienią dynamikę Waszej relacji', 'Ćwiczenia wzmacniające Twoją wewnętrzną siłę i kobiecość', 'Skuteczne metody komunikacji, które przebijają się przez mur obojętności', 'Praktyczne wskazówki, jak odbudować namiętność krok po kroku'].map((item, index) => <li key={index} className="flex items-start" data-id="element-127">
                    <div className="text-red-500 mr-2 mt-1" data-id="element-128">
                      <CheckIcon size={16} data-id="element-129" />
                    </div>
                    <p className="text-gray-700" data-id="element-130">{item}</p>
                  </li>)}
              </ul>
            </div>
            <CTAButton text="Pobieram e-book za 29,99 zł" data-id="element-131" />
          </div>
        </div>
      </div>
    </section>;
};